import script from "./BlueMarkdown.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueMarkdown.vue?vue&type=script&setup=true&lang=js"

import "./BlueMarkdown.vue?vue&type=style&index=0&id=4d79c7c8&lang=css"

const __exports__ = script;

export default __exports__